var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSv(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0f47af",
    d: "M.3 0h53.4v40H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 13.3h53.4v13.4H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m27 23.6.6-.2q.8-.1 1-.4h.2l-.4-.2H28q-.2.3-1.1.4-1-.1-1.2-.3H25l.2.1 1 .4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M25.2 23.2V23h.1l-.2-.1v.2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M25.3 23h-.1v.2l.3-.1zm3.4.2V23h-.2l.3-.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M28.5 23h.2v.2l-.3-.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m25.7 22.9-.1.2h.2zm0 0v.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M25.8 23.2V23z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M26 23h-.1v.2h.2a.1.1 0 0 0-.1-.2m0 0v.2l-.1-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26.2 23.2v.1H26zm.2 0v.2zv.2l-.1-.1zm.2.3v-.2l-.1.1v-.2zv-.2zm.1 0v-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M26.9 23.3h-.1v.2zm0 0v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m27.2 23.5-.2-.2v.2-.2zv-.1zm.1 0v-.3zh.1m.2 0v-.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M27.5 23.2v.2h.1zm0 0 .1.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M27.8 23.2h-.1v.1zh-.1v-.1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M27.8 23v.3h.1V23m0 .1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M27.9 23h.1v.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m28 23 .1.2.1-.1zm.3-.1h-.1l.1.2q.2 0 0-.2m0 0v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e60000",
    fillRule: "evenodd",
    d: "M25 23.7v-.1h-.1m-1.2-.9v-.1m-.5.2v-.1zm0-1.5v-.1zm-.5.2v-.2zm.2-1.4V20zm-.3-1.2h-.1m.4.1v-.1zm.8-1.9V17zm-1.4 3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 24v-.3m0 .3h-.3m-1-1 .1-.2m-.2.2h-.2m-.1-1.5-.2.3-.2-.1h-.1m-.3-1.4.3.2.2-.2m-.3-1.2.1.3.3-.2m0-1.3h.2v.3h.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "M28.1 25.2h-.3l-.1-.2s-.8-.4-1.2-.4l-1.3-.4-1.7-1.3-.5-1.3-.3-1.3.2-1.3q.3-.9 1-1.8L23 19l-.1 1.4c0 .3.2 1.3.6 2 .2.7.5.7 1 1q.3.4.8.6l1.2.4 1.2.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "m23.5 22.9.1-.2.2-.2V22l-.1-.2-.2-.2zm0-.1-.2-.4v-.2q-.1 0 0-.4v-.2l.1-.2v.9zm2.6 1.6h-.3l-.2-.1-.3-.2-.2-.3h.5l.2.3h.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "m26.4 24.5-.6-.3-.2-.1-.3-.3-.2-.3h.3l.4.2.2.2v.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "m26.6 24.6-.6-.4V24l-.3-.3-.1-.4h.3l.2.2.2.4v.2l.1.2zm-.6-.2-.4-.1h-.2q0-.2-.2-.1h-.4l.2.2zm.1 0h-1.6l.3.3h.8v-.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "M26.5 24.6q-.1-.2-.7 0h-.6l-.5.2.4.2h.7l.3-.1.1-.1zm-2-.9-.3-.3-.2-.1-.2-.2h-.3v.2q.2 0 .3.2h.3l.1.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "m24.7 23.8-.4-.3H24l-.3-.2h-.3v.2l.3.2h.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "m24.8 23.9-.5-.2h-1l.1.1q.2 0 .3.2h.6zm0 0v-.7l-.2-.3v-.4l-.3.4v.1l.1.4v.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "m24.8 23.9-.2-.2-.4-.1-.3-.4v-.4l.2-.3.1.2v.2l.2.3.1.4zm-1.3-1H23q0-.3-.2-.3l-.1-.3-.3-.3h.5l.2.2.4.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "m23.5 22.9-.3-.2-.3-.3-.2-.2-.2-.5.3.1.3.1.1.3.2.3zm-.4-1.4v-.4l.1-.2v-.2q.2-.1 0-.4v.1l-.2.1v.2l-.1.2v.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "M23 21.6v-.2h.2v-.2l.1-.1v-.4l-.2.2v.7m-.2-1.6v-.4l.3-.3v.4l-.1.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "M22.8 20.2v-.3l.2-.1v-.2q.3 0 .3-.2v.4l-.2.2-.1.1zm.2 1.4-.2-.2-.4-.1-.1-.2-.2-.2v-.3h.1l.2.1.1.2h.2l.1.3.2.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "m23 21.5-.2-.2-.3-.3-.1-.2-.1-.2v-.4l.1.2.2.1.1.2v.1l.2.2zm-.2-1.1-.1-.2-.4-.3v-.1l-.1-.3v-.3l.1.1.2.1v.2l.2.1v.7",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "m22.8 20.3-.2-.2-.1-.3v-.3q-.2 0-.1-.2V19l.2.2v.1l.2.2zm.1-1.2.2-.1.2-.2.1-.2.2-.2h-.3l-.2.1v.2l-.2.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "M23 19v-.5l.3-.3v.5zm-.1 0q-.2 0-.2-.2v-.2l.2-.3.1.2v.4zm.5-1h.4l.1-.2.1-.1.1-.1H24q-.2 0-.3.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "m23.4 18 .3-.1v-.1l.2-.2v-.3l-.2.1-.1.2q-.2 0-.2.4",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "m23.4 18 .2-.1v-.2l.1-.2v-.2h-.2v.2l-.1.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6 24.3h-.7m1 .1-.6.1h-.7m1.8 0-.4.2-.5.1h-.7m.4-1 .3.2.3.2m-.6-.7.5.4.5.5m-.7-1 .4.3.1.3.2.3.3.2m-3-1.4.5.3m-.6-.1.5.3.7.1m.1.2h-.9l-.5-.2m.8-1.2v.3l.2.5.1.3m.1-1v.5l.1.3v.3l.2.1m-2.4-1.7q.2 0 .3.2l.2.1m.7-.6v1m-.2-1.3v1m-.9-.8.4.3.3.5.3.3M22 20.6l.3.3.2.2m.7-.4v.2l-.2.3v.2m.1-1v.2l-.1.2v.5m-.8-1 .1.2.2.2.2.5.1.2m-.7-2.1v.2l.3.3m.6-.5v.2l-.2.2v.1m.4-.3-.2.2v.2q-.3 0-.3.3m-.3-1.1v.3l.1.2v.3l.1.2m.8-1.7-.2.2-.3.4m.3-.8-.2.4v.1m-.2-.5v.8m1.2-1.4-.4.2m.2-.4-.2.3m0-.4-.1.3-.2.3m.6-.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e60000",
    fillRule: "evenodd",
    d: "M29 23.7h-.1v-.1m1.1-.9v-.1m.5.2h-.1v-.1zm.5-1.3v-.2zm-.3-2.5h-.1m-.9-1.9V17m1.5 3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9 24v-.3m0 .3h.3m1-1-.1-.2H30m.3.2h.2m0-1.5h.1l.2.3.2-.1m.4-1.4-.3.2-.2-.2h-.1m.4-1.2-.2.3-.2-.2m-.1-1.3-.1.3h-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "M25.8 25.2h.3l.1-.2s.7-.4 1.2-.4l1.3-.4 1.7-1.3.5-1.3.2-1.3L31 19l-1-1.8 1 1.8v1.4c0 .3-.2 1.3-.5 2s-.5.7-1 1l-.8.6-1.2.4-1.2.4q-.4.1-.5.4",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "M30.3 22.9v-.2l-.2-.2v-.6l.2-.2v.1l.1.2v.9m0-.1.3-.4v-.2q.1 0 0-.4v-.2l-.2-.2v1.4M28 24.4h.3l.2-.1.3-.2.2-.3h-.5l-.2.3H28l-.2.3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "m27.5 24.5.6-.3.1-.1.3-.3.3-.3h-.4l-.3.2-.2.2-.1.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "M27.3 24.6q.2 0 .5-.4l.2-.2.3-.3.1-.4h-.3l-.2.2-.2.4v.2l-.2.2zm.6-.2.4-.1h.1q0-.2.3-.1h.4l-.2.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "M27.7 24.4h1.6l-.3.3h-.8l-.1-.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "M27.4 24.6q0-.2.6 0h.7l.5.2-.4.2H28l-.3-.1-.1-.1zm2-.9.3-.3.2-.1.2-.2h.2v.2l-.2.2h-.3l-.1.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "m29.2 23.8.4-.3h.3l.3-.2h.3v.2l-.4.2h-.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "m29.1 23.9.5-.2h1l-.2.1-.2.2h-.6zm0 0v-.7l.1-.3.1-.4q.2 0 .2.4v.5l-.1.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "m29.1 23.9.2-.2.4-.1.2-.4v-.4q0-.2-.2-.3v.2l-.1.2-.1.3-.1.4zm1.2-1h.7l.1-.3.2-.3.3-.3H31l-.2.2-.4.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "m30.3 22.9.4-.2.3-.3.2-.2.2-.5-.3.1-.3.1q0 .2-.2.3v.3zm.5-1.4v-.4l-.1-.2-.1-.2v-.4l.1.1.2.1v.2l.1.2v.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "M30.8 21.6v-.2h-.1v-.2l-.1-.1v-.4l.2.2zm.3-1.6v-.4l-.3-.3v.4l.1.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "M31.1 20.2v-.3l-.2-.1-.1-.2-.2-.2v.4l.2.2.1.1zm-.2 1.4.1-.2.5-.1.1-.2.1-.2.1-.3h-.2l-.1.1-.2.2h-.1l-.1.3-.2.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "m30.9 21.5.2-.2.3-.3v-.2l.2-.2v-.4l-.1.2-.2.1-.2.2v.3zm.2-1.1.1-.2q.3 0 .4-.3v-.1l.1-.3v-.3l-.1.1-.2.1v.2l-.2.1v.3l-.1.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "m31.1 20.3.1-.2.2-.3v-.3q.2 0 .1-.2l-.1-.3v.2l-.2.1v.3l-.1.2zm-.2-1.2V19l-.3-.2-.2-.2v-.2h.1l.2.1.2.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "M31 19v-.5l-.4-.3v.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "m31 19 .1-.2v-.2l-.1-.3-.1.2v.4zm-.5-1H30l-.1-.2-.2-.1v-.1h.2l.3.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "m30.4 18-.2-.1v-.1l-.2-.2v-.3l.1.1h.2v.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f601a",
    fillRule: "evenodd",
    d: "m30.5 18-.2-.1v-.2l-.1-.2v-.2h.2v.2l.1.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3 24.3h.7m-1.1.1.7.1h.7m-1.8 0 .4.2.5.1h.7m-.4-1-.3.2-.3.2m.6-.7-.5.4-.5.5m.7-1-.4.3-.2.3-.1.3-.3.2m3-1.4-.5.3m.6-.1-.6.3-.6.1m-.1.2h.9l.4-.2m-.7-1.2v.3l-.2.5q0 .2-.2.3m0-1v.5l-.1.3v.3l-.2.1m2.4-1.7-.4.2v.1m-.8-.6v1m.2-1.3v1m.8-.8-.3.3-.3.5-.3.3m1.4-2.2-.3.3-.2.2m-.7-.4v.2l.1.3.1.2m-.2-1 .1.2v.2l.2.5m.7-1-.1.2-.2.2-.2.5-.1.2m.7-2.1v.2l-.3.3m-.6-.5v.2l.1.2v.1m-.3-.3.1.2.2.2.2.3m.3-1.1v.3l-.1.2v.3l-.2.2m-.7-1.7.2.2.3.4m-.3-.8.2.4v.1m.2-.5v.8m-1.2-1.4.4.2m-.2-.4.2.3m0-.4.1.3.2.3m-.5-.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    fillRule: "evenodd",
    d: "M27 24.4v.3zm0 0 .1-.5h.4v.6l-.4.1zh.2V24h-.1zm-.1.3s-.4.2-.2.6l-.1-.1v.2q-.2 0-.1-.5.3-.4.4-.3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    fillRule: "evenodd",
    d: "M26.9 24.5q0-.2-.4 0s-.2-.5-.1-.6v.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    fillRule: "evenodd",
    d: "m26.9 24.5-.5-.6h.4l.2.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#011322",
    fillRule: "evenodd",
    d: "m26.9 24.5-.3-.2V24l-.2-.1v.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    fillRule: "evenodd",
    d: "m27.1 24.7.2.2.1.5.1-.1h.2l-.1-.1-.1-.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#011322",
    fillRule: "evenodd",
    d: "m27.2 24-.1.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#011d33",
    fillRule: "evenodd",
    d: "m26.9 24.6-.3.2zm.2 0 .2.2zm-.2 0h-.4zm.5-.3v.2l.1-.4V24l-.1.1zm-.4.1v.3-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 24.4v.3zm0 0 .1-.5h.4v.6l-.4.1zh.2V24h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    fillRule: "evenodd",
    d: "M26.6 17v-.5l.2-.7v-.2h.1l.1.2v.4l-.2.3v.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M27 16.5v-.7.4l-.2.3v.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    fillRule: "evenodd",
    d: "M27 16.5v-.3zv.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 16.7v-1.1h-.1v.2l-.3.7v.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "M27 15.6h.1l-.1.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 15.6h.1m-.1 0 .1.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "M26.9 15.6v.2l-.2-.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 15.5-.1.2m0-.2v.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "M27 15.5h.1zh.2l-.1-.2zm0 0h-.2zh-.2zm0-.5v.5l-.2-.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 15v.5l-.2-.1zm0 .3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M27 23h-.2v-.4l.1-.5.1.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    fillRule: "evenodd",
    d: "M27 22.1v.8h.2l.1-.2v-.3h-.1zm0 0-.2.5v.3h-.1l-.2-.2v-.1l.1-.2h.1l.1-.2V22z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.9 22.1-.1.3-.1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.9 22.1-.1.3-.1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 22.1-.2.4q-.2 0 0 .4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 22.1-.2.4q-.2 0 0 .4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 22.1-.2.4q-.1 0 0 .4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.9 22.1-.1.3-.1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.9 22.1-.1.3-.1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.9 22.1-.1.3-.1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.9 22.1-.1.3-.1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.9 22.1-.2.3q-.1.1 0 .4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 22.1-.2.4q-.2 0 0 .4m.2-.8v.3q.3.1.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 22.1v.3q.3.1.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 22.1v.4q.3 0 .2.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 22.1v.4q.3 0 .2.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 22.1v.4q.3 0 .1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 22.1.1.3q.1.1 0 .4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 22.1.1.3.1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 22.1.1.3.1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 22.1.1.3.1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 22.1.1.3.1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 22.1v.4q.2 0 .1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2 22.3v.2l.1.1v.2h-.1l-.1.1h-.4l-.2-.2v-.1l.1-.2h.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m25.1 19.6-.2-.9v-1l.5.5v.3l.1.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    fillRule: "evenodd",
    d: "M25.5 18.9v-.7l.2.3zm-1.2.4V17l.7.7-.1 1.1.2.9-.1.2zm.4 1v-.4l-.1-.3.3.2zm-1 1.5v-.1l-.1-.2v-.3l-.2-.4v-2l.6.4v1l.2.8zm1.2.3.4.2.4.2h.4l.1-.1h.2l.3-.2V22h.1v.2h-.1l-.1.1h-.3l-.1.1H26l-.1.1H25l-.5-.2-.1-.1-.4-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    fillRule: "evenodd",
    d: "M25.8 22.1h1l-.1.1-.3.1h-.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m25.8 22.1.3.2h.3-.2l-.1.1h-.4l-.4-.1-.4-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4 17.3s.1 1 .5 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9 18.3q-.3-.1-.4-.5l-.1-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9 18.3q-.3-.1-.4-.5l-.1-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9 18.3q-.3-.1-.4-.5l-.1-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9 18.3q-.3-.1-.4-.5l-.1-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9 18.3q-.3-.2-.4-.5l-.1-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.9 18.3-.4-.5-.1-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9 18.2q-.3-.1-.4-.4l-.1-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9 18.2q-.3-.1-.4-.4l-.1-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9 18.2q-.3-.1-.4-.4l-.1-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9 18.2q-.3-.2-.4-.5l-.1-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9 18.2q-.3-.2-.4-.5l-.1-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.9 18.2-.4-.5-.1-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.4 17.3.1.4.4.5m-.5-1.2s.3.9.5.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 17.8q-.3 0-.4-.3l-.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 17.8q-.3 0-.4-.3l-.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 17.8-.4-.3-.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 17.8-.4-.3-.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 17.8-.4-.3-.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 17.8-.4-.3-.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 17.8-.4-.4-.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 17.8-.4-.4-.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.4 17 .2.4.3.4m.6.8h.2m-.3-.3.3.2m-.3-.2.3.2m-.3-.2.3.2m-.3-.1h.3m-.3 0h.3m-.3 0h.3m-.3 0h.3m-.3 0h.3m-.3 0h.3m-.3 0h.3m-.2.2h.2m-.2 0h.2m-.2-.1h.2m-.2 0h.2m-.2 0h.2m-.2 0h.2m-.2 0h.2m-.2 0h.2m-.2 0h.2m-.2-.1h.2m-1.4.1v.3l.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.8 19.3-.3-.3-.2-.2v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.8 19.3-.4-.5-.1-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.8 19.3-.3-.3-.1-.2-.1-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.8 19.3-.3-.3-.1-.2-.1-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.8 19.3-.3-.4-.1-.1-.1-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.8 19.3-.3-.4-.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.8 19.3-.4-.5-.1-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.9 19.3-.4-.4v-.1l-.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.9 19.3-.4-.4v-.1l-.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.9 19.3-.4-.4v-.1l-.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.9 19.3-.4-.4v-.1l-.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.9 19.3-.4-.4v-.2l-.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 18.4.3.5.3.4m-.6 0 .7.5.1-.2v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 19.3.7.5v-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 19.3.7.5v-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 19.3.7.4v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 19.3.7.4v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 19.3.7.4v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 19.3.7.4v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 19.3.7.4v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 19.3.7.4v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 19.3.7.4v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 19.3.7.4v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 19.3.7.4v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 19.3.7.4v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 19.3.7.4v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 19.3.7.4v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 19.3.7.3v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 19.3.7.3v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 19.3.7.3v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 19.3.7.3v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 19.3.7.3v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 19.3.7.3v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 19.3.7.3v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 19.3.7.3v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 19.3.7.3v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 19.3.7.3v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 19.3.7.3v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 19.3.7.3v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.3 19.3.7.3v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3 19.3s.6.3.7.2l-.1-.1h.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3 19.3s.6.3.7.2l-.1-.2h.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3 19.3s.6.3.7.2l-.1-.2.1.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3 19.3s.7.4.7.2l-.1-.2h.1m-.8 1.7-.5.8v-.1l-.2-.2v-.3l-.1-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.4v.3l.1.2.1.1.5-.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.4v.2l.1.3.1.1.5-.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.4v.2l.1.3.1.1.5-.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.4v.2l.1.3.1.1.5-.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.4v.2l.1.3.1.1.5-.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.4v.2l.1.3h.1l.5-.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.4v.2l.1.2.1.2.5-.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.4v.2l.1.2.1.2.5-.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.4v.2l.1.2.1.2.5-.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.4v.2l.1.2.1.2.5-.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.4v.2l.1.2.1.1.5-.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.4v.2l.1.2.1.1.5-.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.4v.2l.1.2.1.1.5-.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.4v.2l.1.2.1.1.5-.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.4v.2l.1.2.1.1.5-.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.4v.2l.1.2.1.1.5-.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.4v.2l.1.2h.1l.5-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.4v.2l.1.2h.1l.5-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.4v.1l.1.2.1.2.5-.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.3v.2l.1.2.1.2.5-.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.3v.2l.1.2.1.2.5-.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.3v.2l.1.2.1.1.5-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.3v.2l.1.2.1.1.5-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.3v.2l.1.2.1.1.5-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.3v.2l.1.2.1.1.5-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.3v.2l.1.2.1.1.5-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.3v.2l.1.2h.1l.5-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.3v.2l.1.2h.1l.5-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.3v.2l.1.2h.1l.5-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.3v.2l.1.2h.1l.5-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.3v.2l.1.1.1.2.5-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.3v.2l.1.1.1.1.5-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.3v.2l.1.1.1.1.5-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.3v.2l.1.1.1.1.5-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.3v.2l.1.1.1.1.5-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.3v.1l.1.2.1.1.5-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.3v.1l.1.2h.1c.1.1.5-.4.5-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.3v.1l.1.2h.1c.1.1.5-.4.5-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.3v.1l.1.2h.1c.1.1.5-.4.5-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.3v.1l.1.2h.1l.5-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.3v.1l.1.2h.1l.5-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.3v.1l.1.2h.1l.5-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.3v.1l.1.1.1.1.5-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.3.1.2.2.1.4-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.3.1.2.2.1.4-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.3.1.2.2.1.4-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.2v.2l.1.1.1.1.5-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.2v.2l.1.1h.1c.1.1.4-.3.5-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.2v.2l.2.1c.1.1.4-.3.5-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.2v.2l.2.1c.1.1.4-.3.5-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.2v.2h.2v.2l.5-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.2v.2h.2v.2l.5-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.2v.1l.2.2.5-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.2v.1l.2.2.5-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.2v.1l.2.2.5-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.2v.1l.2.1v.1l.5-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.2v.1l.2.1v.1l.5-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.2v.1l.2.1v.1l.5-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.2v.1l.2.1q.3 0 .5-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.2v.1l.2.1q.3 0 .5-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.2v.1l.2.1q.3 0 .5-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.2.2.2.5-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.2.2.2.5-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.2.2.2.5-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.2.2.2.5-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.2.2.2.5-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.2.2.2.5-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.2.2.1v.1l.5-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.2.2.1q.3.1.5-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.2.2.1q.3.1.5-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.2.2.1q.3.1.5-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.1v.1l.2.1q.3.1.5-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.1v.1l.2.1.5-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.1v.1l.2.1.5-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.1v.1h.2v.1h.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.1v.1h.2v.1l.5-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.1v.1h.2v.1l.5-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.1.2.2.5-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.1.2.2.5-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.1.2.2.5-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.1.2.1h.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.1.2.1h.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.1.2.1h.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.1.2.1h.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 20.8.1.1.2.1h.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4 20.8h.1v.1l.2.1h.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4 20.8h.1v.1l.3.1h.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4 20.8h.1v.1l.3.1h.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2 21h-.6l-.1-.1h-.1zm-.8-1.5.1.6q0 .2.5.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19.5.1.6q0 .2.5.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19.5.1.6q.2.4.5.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19.5.1.6.5.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19.5.1.6.5.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19.5.1.6.5.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19.5.1.6.5.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19.5.1.6.5.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19.5.1.6.5.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19.5.2.6.4.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19.5.2.6.4.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19.5.2.5q-.1.1.4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19.5.2.5q-.1.1.4.5m-.6-1.4s0 .8.6 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19.1.2.5q0 .3.4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19.1.2.5q0 .3.4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19.1.2.5q0 .3.4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19.1.2.5q0 .3.4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19.1.2.5.4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19.1.2.5q0 .3.4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19.1.2.5.4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19.1.2.5.4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19.1.2.5.4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19.1.2.5.4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19.1.2.5.4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19.1.2.5.4.5m-.6-1.1s.2.5.6.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19 .2.4.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19 .2.4.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19 .2.4.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19 .2.3.4.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19 .2.3.4.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19 .2.3.4.4m-.6-.7.6.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19 .3.3q0 .3.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19 .3.3q0 .3.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19 .3.3q0 .3.3.4m-.6-.7.6.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19 .3.3.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19 .3.3.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4 19 .3.3.3.4m.6 0 .3.1m-.3.2.3-.1m-.3-.1h.3m-.3 0h.3m-.3 0h.3m-.3 0h.3m-.3 0h.3m-.3 0h.3m-.3 0h.3m-.3.1h.3m-.3 0h.3m-.3.1.3-.1m-.3.1.3-.1m-.3.1.3-.1m-.3.1.3-.1m-.3.1.3-.1m-.3.1.3-.1m-.3.1.3-.1m-.3.1.3-.2m-.3.1h.3m-.3 0h.3m0 2.2H24m.9 0H24m.9 0H24m.9 0H24m.9 0H24m.9 0H24m.9 0h-.8m.8 0h-.8m.8 0h-.8m.8 0-.2.1H24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.1 22.1.6.1h.2m.1.3h.7m-.7 0h.6m-.6 0h.6m-.6-.1.3.1h.3m-.6-.1h.6m-.6 0h.5m-.5 0h.5m-.6 0h.6m-.5.1h.7m-.8-.1h.6m.8 0h.3q.3-.2.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3 22.4h.2l.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3 22.4h.2l.1-.1.1-.1V22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3 22.4h.2l.1-.1.1-.1v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3 22.4h.2l.1-.1h.1V22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2 22.4h.3l.1-.1h.1V22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.3 22.5.3-.2h.1l.1-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.3 22.5.3-.2h.1l.1-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.3 22.5.3-.2h.1V22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.2 22.5.4-.2h.1V22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.2 22.5.4-.2h.1V22m0 .1h-.9m.9 0h-.9m.9 0h-.9m.9 0h-.9m.9 0h-.9m.9 0h-.9m.9 0h-.8m.8 0h-.8m.8 0h-.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.7 22.1-.2.1h-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.9 22.1.6.1h.2m-2.4-2.9V17l1.5 1.6m-2 3.3-.2-.1v-.5l-.2-.4v-2l1.5 1m2 2.3-.1.1v.1h-.1l-.1.1h-.3l-.1.1H26l-.1.1H25l-.5-.2-.1-.1-.4-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "m25 19.8-1.6-1zm-1.6-1v-.2h.1zl.1-.1h-.1zm-.1 0h-.1v.1zh-.1v-.1zm-.3-.3h.3v.2h-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1 18.6h.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "M23.3 18.9v-.1l.1.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4 18.8v.2m0-.1v.1m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "m25.7 18.5-1.3-1.6zm-1.3-1.6v-.2h.1zh.1v-.1zm-.1 0h-.1v.1zv.1h-.1zm0 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "m24 16.6.3.1v.2h-.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2 16.7v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "M24.3 17v.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4 17v.2m0-.2v.2m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m28.8 19.6.2-.9v-1l-.6.5v.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    fillRule: "evenodd",
    d: "M28.4 18.9v-.7l-.3.3zm1.2.4V17l-.7.7v1.1l-.1.9.1.2zm-.4 1v-.7l-.3.2zm1 1.5v-.1l.1-.2v-.3l.2-.4v-2l-.7.4v1l-.2.8zm-1.2.3-.4.2-.4.2h-.4l-.1-.1h-.3l-.2-.2V22H27v.1h.1v.1h.1v.1h.4l.1.1h.2l.1.1h.9l.5-.2.1-.1.3-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    fillRule: "evenodd",
    d: "M28 22.1h-.8v.1l.2.1h.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m28 22.1-.3.2h-.2.2l.1.1h.4l.4-.1.4-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5 17.3s-.1 1-.5 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 18.3q.3-.1.4-.5v-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 18.3q.3-.1.4-.5v-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 18.3q.3-.1.4-.5v-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 18.3q.3-.1.4-.5v-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 18.3q.3-.2.4-.5l.1-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 18.3.4-.5.1-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 18.2q.3-.1.4-.4v-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 18.2q.3-.1.4-.4v-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 18.2q.3-.1.4-.4v-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 18.2q.3-.2.4-.5v-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 18.2q.3-.2.3-.5l.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 18.2q.3-.2.3-.5l.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.5 17.3-.2.4q0 .2-.3.5m.5-1.2s-.3.9-.6.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 17.8.3-.3.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 17.8.3-.3.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 17.8.3-.3.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 17.8.3-.3.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 17.8.3-.3.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 17.8.3-.3.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 17.8.3-.4.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 17.8.3-.4.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.5 17-.2.4-.3.4m-.6.8h-.2m.2-.3-.2.2m.2-.2-.2.2m.2-.2-.2.2m.2-.1h-.2m.2 0h-.2m.2 0h-.2m.2 0h-.3m.3 0h-.3m.3 0h-.3m.3 0h-.3m.3.2h-.2m.2 0h-.2m.2-.1h-.2m.2 0h-.2m.2 0h-.2m.2 0h-.3m.3 0h-.3m.3 0h-.3m.3 0h-.3m.3-.1h-.3m1.5.1v.3l-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 19.3.4-.3.1-.2.1-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 19.3.5-.5.1-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 19.3.4-.3.1-.2.1-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 19.3.4-.3.1-.2.1-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 19.3.4-.4.1-.1.1-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 19.3.4-.4.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 19.3.5-.5.1-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 19.3.4-.4v-.1l.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 19.3.4-.4v-.1l.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 19.3.3-.4.2-.1.1-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 19.3.3-.4.2-.1.1-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 19.3.3-.4.1-.2.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 18.4-.3.5-.3.4m.6 0-.7.5-.1-.2v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 19.3-.7.5-.1-.2v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 19.3-.7.5-.1-.2v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 19.3-.7.4v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 19.3-.7.4v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 19.3-.7.4v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 19.3-.7.4v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 19.3-.7.4v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 19.3-.7.4v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 19.3-.7.4v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 19.3-.7.4v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 19.3-.7.4v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 19.3-.7.4v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 19.3-.7.4v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 19.3-.7.4v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 19.3-.7.3v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 19.3-.7.3v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 19.3-.7.3v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 19.3-.7.3v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 19.3-.7.3v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 19.3-.7.3v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 19.3-.7.3v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 19.3-.7.3v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 19.3-.7.3v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 19.3-.7.3v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 19.3-.7.3v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 19.3-.7.3v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 19.3-.7.3v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6 19.3s-.6.3-.7.2v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6 19.3s-.6.3-.7.2v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6 19.3s-.6.3-.7.2l.1-.2-.1.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6 19.3s-.7.4-.7.2l.1-.2h-.1m.7 1.7.5.8.2-.1v-.5l.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.4v.3l-.1.2-.2.1-.5-.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.4v.2l-.1.3-.2.1-.5-.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.4v.2l-.1.3-.2.1-.5-.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.4v.2l-.1.3-.2.1-.5-.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.4v.2l-.1.3-.2.1-.5-.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.4v.2l-.1.3H30l-.5-.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.4v.2l-.1.2-.2.2-.5-.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.4v.2l-.1.2-.2.2-.5-.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.4v.2l-.1.2-.2.2-.5-.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.4v.2l-.1.2-.2.2-.5-.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.4v.2l-.1.2-.2.1-.5-.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.4v.2l-.1.2-.2.1-.5-.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.4v.2l-.1.2-.2.1-.5-.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.4v.2l-.1.2-.2.1-.5-.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.4v.2l-.1.2-.2.1-.5-.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.4v.2l-.1.2-.2.1-.5-.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.4v.2l-.1.2H30l-.5-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.4v.2l-.1.2H30l-.5-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.4v.1l-.1.2-.2.2-.5-.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.3v.2l-.1.2-.2.2-.5-.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.3v.2l-.1.2-.2.2-.5-.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.3v.2l-.1.2-.2.1-.5-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.3v.2l-.1.2-.2.1-.5-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.3v.2l-.1.2-.2.1-.5-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.3v.2l-.1.2-.2.1-.5-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.3v.2l-.1.2-.2.1-.5-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.3v.2l-.2.2c-.1.1-.5-.5-.6-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.3v.2l-.2.2-.6-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.3v.2l-.2.2-.6-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.3v.2l-.2.2-.6-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.3v.2l-.2.1v.2l-.6-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.3v.2l-.2.1v.1l-.6-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.3v.2l-.2.1v.1l-.6-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.3v.2l-.2.1v.1l-.6-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.3v.2l-.2.1v.1l-.6-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.3v.1l-.2.2v.1l-.6-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.3v.1l-.2.2c-.1.1-.5-.4-.6-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.3v.1l-.2.2c-.1.1-.5-.4-.6-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.3v.1l-.2.2c-.1.1-.5-.4-.6-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.3v.1l-.2.2-.6-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.3v.1l-.2.2-.6-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.3v.1l-.2.2-.6-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.3v.1l-.2.1v.1l-.6-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.3-.2.2v.1l-.6-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.3-.2.2v.1l-.6-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.3-.2.2v.1l-.6-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.2v.2l-.2.1v.1l-.6-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.2v.2l-.2.1c-.1.1-.5-.3-.6-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.2v.2l-.2.1c-.1.1-.5-.3-.6-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.2v.2l-.2.1c-.1.1-.5-.3-.6-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.2v.2h-.2v.2l-.6-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.2v.2h-.2v.2l-.6-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.2v.1l-.2.2-.6-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.2v.1l-.2.2-.6-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.2v.1l-.2.2-.6-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.2v.1l-.2.1v.1l-.6-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.2v.1l-.2.1v.1l-.6-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.2v.1l-.2.1v.1l-.6-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.2v.1l-.2.1-.6-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.2v.1l-.2.1-.6-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.2v.1l-.2.1-.6-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.2-.2.2-.6-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.2-.2.2-.6-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.2-.2.2-.6-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.2-.2.2-.6-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.2-.2.2-.6-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.2-.2.2-.6-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.2-.2.1v.1l-.6-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.2-.2.1q-.3.1-.6-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.2-.2.1q-.3.1-.6-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.2-.2.1q-.3.1-.6-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.1v.1l-.2.1q-.3.1-.6-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.1v.1l-.2.1-.6-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.1v.1l-.2.1-.6-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.1v.1h-.2v.1h-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.1v.1h-.2v.1l-.6-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.1v.1h-.2v.1l-.6-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.1-.2.2-.6-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.1h-.1v.2H30l-.5-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.1h-.1v.2H30l-.5-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.1h-.1v.1h-.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.1h-.1v.1h-.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.1h-.1l-.1.1h-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.1h-.1l-.1.1h-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 20.8-.1.1h-.1l-.1.1h-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 20.8h-.1l-.1.1-.1.1h-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 20.8h-.1l-.1.1-.2.1h-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 20.8h-.1l-.1.1-.2.1h-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6 21h.7v-.1h.2zm.9-1.5-.1.6q0 .2-.5.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19.5-.1.6q0 .2-.5.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19.5-.1.6q-.2.4-.5.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19.5-.1.6-.5.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19.5-.1.6-.5.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19.5-.1.6-.5.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19.5-.2.6q.1.1-.4.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19.5-.2.6-.4.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19.5-.2.6-.4.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19.5-.2.6-.4.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19.5-.2.6-.4.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19.5-.2.5q.1.1-.4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19.5-.2.5q.1.1-.4.5m.6-1.4s-.1.8-.6 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19.1-.2.5q0 .3-.4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19.1-.2.5q0 .3-.4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19.1-.2.5q0 .3-.4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19.1-.2.5q0 .3-.4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19.1-.2.5-.4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19.1-.2.5-.4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19.1-.2.5-.4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19.1-.2.5-.4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19.1-.2.5-.4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19.1-.2.5-.4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19.1-.2.5-.4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19.1-.2.5-.4.5m.6-1.1s-.2.5-.6.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19-.2.4-.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19-.2.4-.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19-.3.4-.3.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19-.3.3q0 .3-.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19-.3.3-.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19-.3.3q0 .3-.3.4m.6-.7-.6.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19-.3.3q0 .3-.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19-.3.3q0 .3-.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19-.3.3q0 .3-.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19-.3.3-.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19-.3.3-.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19-.3.3-.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.5 19-.3.3-.3.4m-.6 0-.3.1m.2.2-.2-.1m.3-.1H29m.3 0H29m.3 0H29m.3 0H29m.3 0H29m.3 0H29m.3 0H29m.3.1H29m.3 0H29m.3.1-.3-.1m.3.1-.3-.1m.3.1-.3-.1m.3.1-.3-.1m.3.1-.3-.1m.3.1-.3-.1m.3.1-.3-.1m.3.1-.3-.2m.3.1H29m.3 0h-.4m.1 2.2h.8m-.8 0h.8m-.8 0h.8m-.8 0h.8m-.8 0h.8m-.8 0h.8m-.8 0h.8m-.8 0h.8m-.8 0h.8m-.8 0 .2.1h.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.8 22.1-.6.1H29m-.1.3h-.7m.7 0h-.7m.8 0h-.8m.8-.1-.5.1h-.2m.7-.1h-.7m.7 0h-.7m.7 0h-.6m.6 0h-.6m.5.1h-.7m.8-.1h-.7m-.7 0h-.3l-.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6 22.4h-.2L27 22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6 22.4h-.2l-.2-.1V22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6 22.4h-.2l-.2-.1V22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6 22.4h-.2l-.1-.1h-.1V22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6 22.4h-.2l-.1-.1H27V22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.6 22.5-.3-.2H27V22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.6 22.5-.3-.2H27V22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.6 22.5-.3-.2H27V22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.6 22.5-.3-.2H27V22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.7 22.5-.4-.2H27V22m.2.1h.9m-.9 0h.9m-.9 0h.8m-.8 0h.8m-.8 0h.8m-.8 0h.8m-.8 0h.8m-.8 0h.8m-.8 0h.8m-.8 0 .2.1h.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 22.1-.6.1h-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6 19.3V17L28 18.5m2 3.3.2-.1v-.5l.2-.4v-2l-1.6 1M27 22.1v.1h.1v.1h.1v.1h.4l.1.1h.2l.1.1h.9l.5-.2.1-.1.3-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "m29 19.8 1.5-1zm1.5-1v-.2h-.1zh-.1v-.1h.1zm.1 0h.1v.1zl.1-.1zm.3-.3h-.3v.2h.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8 18.6h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "M30.6 18.9v-.1h-.1v.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 18.8v.2m0-.1v.1m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "m28.1 18.5 1.4-1.6zm1.4-1.6v-.2h-.1zh-.1v-.1zm0 0h.2v.1zv.1h.1zm0 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "m29.8 16.6-.3.1v.2h.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7 16.7h-.1v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "M29.6 17h-.1v.2h.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5 17v.2m0-.2v.2m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M27 16.5 23.5 22h6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m27 16.9-3 5h6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007e93",
    d: "M24.8 20.4 24 22h6l-.8-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4 17.7.5-.1.6.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4 17.8q.2-.2.5-.2l.6.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4 17.8q.2-.2.5-.2.4 0 .6.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4 17.8.5-.2q.4 0 .6.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4 17.8q.2-.2.5-.2.4 0 .6.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4 17.8q.2-.2.5-.2.4 0 .6.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4 17.8q.2-.2.5-.2.4 0 .6.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4 17.8.5-.2q.4 0 .7.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4 17.8.5-.2q.4 0 .7.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4 17.8.6-.2.6.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4 17.8.5-.2q.4 0 .7.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4 17.8.5-.2q.4 0 .6.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4 17.8q.2-.2.5-.2.4 0 .6.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4 17.8q.2-.2.5-.2.4 0 .6.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4 17.8q.2-.2.5-.2.5 0 .6.2m-.9-.4h.7m-.7 0h.7m-.7 0h.7m-.7 0h.7m-.7 0h.7m-.7 0h.7m-.7.1q0-.2.3-.1h.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6 17.5q0-.2.3-.1h.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.6 17.5.3-.1h.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.6 17.5.3-.1h.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.6 17.5.3-.1h.4m-.8.2a1 1 0 0 1 .9 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.5 17.6.4-.1.5.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.5 17.6.4-.1h.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.5 17.6.4-.2q.3 0 .5.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.5 17.6.4-.2q.3 0 .5.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.5 17.6.4-.2q.3 0 .5.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.5 17.6.4-.2q.3 0 .5.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.5 17.6.4-.2q.3 0 .5.2m-.9-.1h.9m-.9 0h.9m-.8 0h.7m-.7 0h.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.6 17.5.3-.1.4.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.6 17.5.3-.1.4.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.6 17.5.3-.1h.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.6 17.5.3-.1h.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.6 17.5.3-.1h.4m-.8.2.4-.1.5.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.5 17.6.4-.1.5.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.5 17.6.4-.1.5.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.5 17.6.4-.1.5.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.5 17.7.4-.2.5.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.5 17.7.4-.2q.3 0 .5.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.5 17.7.4-.2q.3 0 .5.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.5 17.7.4-.2q.3 0 .5.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.5 17.7.4-.2q.3 0 .5.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4 17.7.5-.1.6.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4 17.7.5-.2.6.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4 17.7q.3-.2.6-.1l.4.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4 17.7.5-.2.6.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4 17.7.5-.2q.3 0 .5.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4 17.7.5-.2q.3 0 .5.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4 17.7.5-.2q.3 0 .5.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4 17.7.5-.2q.3 0 .5.2m-.1-.3h-.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6 18q-.3-.4-.7-.4t-.5.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.5 17.7-.6-.1-.5.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 17.8q-.2-.2-.6-.2t-.5.2m1-.2-.5-.1-.4.1m.8-.1-.4-.1h-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.4 17.7-.5-.2-.5.2m-.1.2.6-.2.7.2.6 1a1.3 1.3 0 1 1-2.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 17.7.6.2.6 1q-.2 1.3-1.2 1.3-1.2 0-1.3-1.2l.6-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 17.8.6.1.6 1q-.1 1.3-1.3 1.3a1.2 1.2 0 0 1-1.2-1.2l.7-1q.2-.2.5-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 17.8q.3 0 .5.2l.6 1a1.2 1.2 0 0 1-1.2 1.2q-1-.2-1.2-1.2l.7-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 17.9.5.1.6 1q0 1-1.2 1.1-1-.1-1.1-1.1l.6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 17.9.5.2.5.9q-.1 1-1 1-1.1 0-1.2-1l.6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 18h.5l.5 1q-.1 1-1 1a1 1 0 0 1-1.1-1l.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 18 .4.1.6.9a1 1 0 0 1-1.5 1 1 1 0 0 1-.6-1l.5-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 18 .4.1.5.9a1 1 0 0 1-1.3.9 1 1 0 0 1-.6-1l.5-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 18.2.3.1.4.7a1 1 0 0 1-.8.8 1 1 0 0 1-.7-.8l.4-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 18.3h.3l.4.7a1 1 0 0 1-1 .7l-.5-.7.4-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 18.3.3.1.3.6a.7.7 0 1 1-1.3 0l.3-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 18.4h.3l.3.6a.6.6 0 0 1-1.1.4l-.2-.4.3-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 17.8.6.1.6 1a1.3 1.3 0 0 1-1.3 1.3 1.3 1.3 0 0 1-1.2-1.2l.6-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 17.8q.3 0 .5.2l.6 1a1.2 1.2 0 1 1-2.4 0l.7-1q.2-.2.5-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 17.8.5.2.6 1q0 1-1.2 1.2-1-.2-1.1-1.2l.6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 17.8.5.2.6 1a1.2 1.2 0 0 1-1.2 1.1 1 1 0 0 1-1.1-1.1l.6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 17.9.5.1.6 1q0 1-1.2 1.1-1-.1-1-1.1l.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 18h.5l.5 1q-.1 1-1 1a1 1 0 0 1-1.1-1l.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 18h.5l.5 1q-.1 1-1 1a1 1 0 0 1-1.1-1l.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 18 .4.1.6.9q-.1 1-1 1a1 1 0 0 1-1.1-1l.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 18 .4.1.5.9a1 1 0 1 1-2 0l.6-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 18 .4.2.5.8q0 .9-1 1a1 1 0 0 1-1-1l.6-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 18 .4.2.5.8q0 .9-1 1a1 1 0 0 1-1-1l.6-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 18 .4.2.5.8a1 1 0 0 1-1.9 0l.5-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 18 .4.2.5.8q-.1.8-1 .9a1 1 0 0 1-.9-1l.5-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 18 .4.2.4.8a1 1 0 0 1-1.2.8 1 1 0 0 1-.6-.8l.5-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 18.1.4.1.4.8q0 .8-.9.9a1 1 0 0 1-.8-1l.4-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 18.1.4.1.4.8q0 .8-.9.9a1 1 0 0 1-.8-1l.4-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 18.1.4.2.4.7q0 .7-.9.8a1 1 0 0 1-.8-.8l.4-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 18.2h.4l.4.8q0 .7-.9.8a1 1 0 0 1-.8-.8l.4-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 18.2.3.1.5.7q0 .7-.9.8a1 1 0 0 1-.8-.8l.4-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 18.2.3.1.4.7a.8.8 0 0 1-1.6 0l.5-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 18.2.3.1.4.7q0 .7-.8.8a1 1 0 0 1-.7-.8l.4-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 18.3h.3l.4.7a1 1 0 0 1-.8.7 1 1 0 0 1-.7-.7l.4-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 18.3h.3l.3.7a1 1 0 0 1-.7.7 1 1 0 0 1-.7-.7l.4-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 18.3.3.1.3.6a.7.7 0 0 1-1.4 0l.4-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 18.3.3.1.3.6a1 1 0 0 1-.7.7 1 1 0 0 1-.6-.7l.3-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 18.4h.3l.3.6a.6.6 0 0 1-.9.6l-.4-.6.3-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 18.4h.2l.4.6a.6.6 0 0 1-1.3 0q0-.3.3-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 18.4h.2l.3.6a.6.6 0 1 1-1.2 0l.3-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 18.4.2.1.3.5-.6.6-.5-.6.3-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 18.4.2.1.3.5a.6.6 0 1 1-1.1 0l.3-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 18.5h.2l.3.5a.5.5 0 0 1-.6.5l-.5-.5.3-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 18.5h.2l.3.5a.5.5 0 0 1-1 0q0-.3.2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 18.5h.2l.2.5-.5.5-.5-.5.3-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 18.5h.2l.2.5-.5.5-.4-.5q0-.3.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 18.5h.2l.2.5a.5.5 0 1 1-1 0l.3-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 18.5.2.1.2.4a.5.5 0 1 1-1 0l.3-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 18.6h.2l.2.4a.4.4 0 0 1-.5.4.4.4 0 0 1-.4-.4l.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 18.6h.2l.2.4a.4.4 0 0 1-.9 0 .4.4 0 0 1 .4-.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 19.4a.4.4 0 1 0 0-.8.4.4 0 0 0 0 .8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M27 19.4a.4.4 0 0 0 .4-.4.4.4 0 0 0-.9 0 .4.4 0 0 0 .4.4",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 18.6v-.2m0 .2v-.2m0 .2v-.2m-.1.2v-.2m0 .2v-.2m0 .2-.1-.2m0 .2-.1-.2m0 .2v-.2m0 .3-.1-.2m0 .2v-.2m0 .2-.1-.1m.1.1h-.2m.2 0h-.2m.2.1h-.2m.2 0h-.3m.2.1h-.2m.2 0h-.2m.2 0h-.2m.2.1h-.2m.2 0-.2.1m.3 0h-.3m.3 0-.2.1m.2 0-.2.1m.2 0-.5.3m.5-.3-.5.4m.6-.4-.5.5m.5-.5-.3.4m.3-.3-.3.5m.4-.5-.2.4m.2-.4-.2.6m.3-.6-.1.4m.1-.4v.6m0-.6.1.2m0-.2.1.6m0-.6v.3m0-.3.3.5m-.3-.6.3.5m-.2-.5.4.5m-.4-.5.4.4m-.4-.4.6.4m-.5-.5.3.2m-.3-.2.2.1m-.2-.1h.2m-.2 0h.2m-.2-.1h.3m-.3 0h.3m-.3-.1h.3m-.3 0h.3m-.3 0 .3-.1m-.3 0 .2-.1m-.2 0h.2m-.2 0 .2-.1m-.2 0h.1m-.2 0 .2-.1m-.2 0h.2m-.2 0 .1-.1m-.2.1.1-.2m-.1.2v-.2m0 .2v-.2m-.2-.3v-.2m-.1.2v-.2m-.2.2-.1-.1m-.1.5-.2-.1m0 .2H26m.1.4H26m.1.2H26m.2.2H26m1.8.2h.2m0-.4h.1M28 19h.1m-.2-.2h.2m-.3-.2h.2m-.3-.1.2-.1m-.3 0V18m-.4 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e60000",
    fillRule: "evenodd",
    d: "M27.2 19.2h-.4zm-.3-.1v-.3h.2l.1.2v.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8 19.1h.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "M27 19.8v-.6zv.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e60000",
    fillRule: "evenodd",
    d: "M26.3 19.3h-.1zm-.1 0v-.1q0-.2 0 0H26m0-.4v.1zm0-.1v-.1zh.1zv-.1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e60000",
    d: "m26.3 18.5-.1.1h.1m0 0v.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e60000",
    fillRule: "evenodd",
    d: "M26.5 18.5h-.2v-.2.1zm0 0v-.2zm0-.2h.1v.1zl.1-.1m.4 0v-.1zh-.1l-.1-.1v.2-.2.1l.1-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e60000",
    d: "M27 18.1v.2zm0 0v.1m0 .1v.1m.1 0v.1q.2 0 0 0h.1zm0 0h.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e60000",
    fillRule: "evenodd",
    d: "M27.3 18.3v.1zh.1v.1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e60000",
    d: "m27.6 18.4-.2.1h.2zm0 0v.1h-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e60000",
    fillRule: "evenodd",
    d: "M27.7 18.6h-.1zm0 .3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e60000",
    d: "M27.7 19h.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e60000",
    fillRule: "evenodd",
    d: "M27.7 19.1v.1h-.1zl.1.1m-.1.2h.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 16.9-3 5h6zm.1 4.4h2.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "M24.8 21.5h2.9l.4-.1.5.1h1.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4 21.3h4.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "M24.1 21.8H29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2 21.6q.2-.2.4-.1h.6m-.1-.2h.8m2.1.6h1.1l.4-.1.4.1m-1.5-.7h1.1m-5.4.7.4-.1h2.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 0.1,
    d: "M24.5 21.6h4.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "M24.6 20.8h.1v-.2h.2l.3-.3.5-.4h.2l.4.2.2.2h.2v.1l.2.1.3.3.2.2.2.2h-3.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "M27.6 21.1h-.2l-.2-.2v-.1l-.3-.3h-.2v-.1l-.2-.1-.1-.2h.3l.3.1.2.2h.2v.1l.1.1.2.2.2.2.2.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "m27 20.2.2.2h.2v.1l.1.1.2.2.2.2.2.1h.4l-.1-.1-.2-.1-.2-.3h-.2l-.1-.2-.2-.1-.2-.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "m27.6 20.4.1.1.2.1.2.2.2.2h.6-.2v-.1h-.1l-.2-.2-.1-.1h-.1q0-.2-.2-.2v-.1h-.3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "M29 21h-.2v-.1h-.1l-.2-.2-.1-.1h-.1l-.1-.2h.4l.1.2h.1l.1.1.2.1zh.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4 20h.1m-.2.1h.1m-.2.2h.1m-1 .8h.6m.3-.8h.2m-.3.2h.1m-.2 0h.2m0 .1h-.3m.3 0h-.3m0 .1h.2m-.3 0h.3m-.3 0h.3m-.4 0 .2.1h.2m-.4 0h.3m-.4 0 .3.1h.1m-.4 0h.4m-.4 0h.4m-.4.1h.4m-.5 0h.4m.5-.3v.1h.1m-.2 0h.2m-.2 0h.2m-.2.1h.2m-.2 0h.2m-.3.1h.3m-.3 0h.3m-.3 0 .2.1m-.2 0h.3m.1-.1h.2m-.2 0h.2m-.2.1h.3m-.3 0h.4m-1 0h.1m.9 0h.3m-.4 0h.4m-1 0h-.2m1-.9h.1m0 .2h.1m.1.2h.1m0 .2h.1m0 .1h.2m0 0h-.2m0 0h.2m0 .1h-.2m0 0h.3m0 0-.2.1m0 0h.3m-.2 0h.2m0 0h.4m-.3 0h.3m0 0h.1m0 0h.1m0 0h.5m-.5 0h.5m-1-.8h.1m.4.3H27m.2 0h-.1m0 .1h.2m0 .2h-.1m0 0h.2m0 0h-.2m0 .1h.3m0 0h-.2m.1 0h.3m0 0h-.2m0 .1h.2m-.2 0h.2m-1.3-.9h.1m.4.5h.1m0 0h.2m0 .1h-.1m.1.1h.2m0 0h.2m0 0h-.2m0 0h.3m0 0v.1m0 0h.2m0 0h.2m-.1.1h.2m-.7-.4h.2m0 0v.1m.1.1h.2m0 0h.2m0 0H28m0 .1h.3m0 0h-.2m0 0h.2m-.7-.2h.2m.3.1h.2m0 0h-.2m0 0h.2m0 0h.2m0 0h.2m0 0-.1.1m-.9-.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M24.3 24.9v.4h-.2l.1.4h.2l.4-.6h-.2l-.1.2V25zm0 .5h.1v.2q-.2 0-.1-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "m23.7 25.2.1-.1-.2-.1v-.1h.3l-.1-.2v-.1l.4.2-.4.6-.4-.2.1-.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m23.6 24.4-.2.2q-.3-.3-.4 0v.3l.2.1zm-.4.2h.1l-.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "m22.7 24.6-.1-.2.3-.2v-.3h-.2l-.3.4V24l.2-.2q.3-.3.5 0v.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M22.4 23.2v.2H22q-.3.1 0 .4v.1l.6-.4v-.2zm0 .1.1.1-.1.1zm-.2.2v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "m22.4 23-.7.3v-.1l.5-.3v-.2zm-1-.4.7-.2-.6.4zm0-.7v.1q0 .3.2.2l.2-.3-.1-.1.1-.1.1.2-.2.4q-.3 0-.5-.2v-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m21.7 20.9-.7.4v.1l.8.2v-.2h-.2V21h.1zm-.2.3v.2h-.3zm-.2-1.7q-.3 0-.3.4v.2h.7V20zm0 .2q.3 0 .2.2h-.4q0-.2.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "M21.2 19.1h.1V19h.2v.3h.1l.1-.2h.1v.4l-.8-.2.1-.3h.1zm.3-1 .1.1V18h.2v.3h.1v-.2h.2l-.1.4-.7-.2.1-.4h.2zm.7-.1-.6-.4.5.2.1-.2h.2zm.2-1.3h-.2v.1c.2.1.3-.2.5 0v.3l-.2.1v-.1h.1v-.2h-.2q0 .2-.2 0v-.2l.1-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m22.7 16-.1.1.3.7h.1v-.2l.1-.2h.3zm0 .2.3.1v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "m23.5 16.3-.4-.6v-.1l.5.5.1-.2.1.1zM24 15l.1-.1.2.8-.7-.4.1-.1.4.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M24.6 14.7h-.2v.9h.2v-.2l.3-.2v.2l.2-.1zm0 .3.2.2h-.2zm.8-.5H25l.3.8.1-.1a.4.4 0 0 0 .3-.5zm0 .1.1.2-.1.3-.2-.4zm.8-.3-.3.4.4.3.3-.4zm0 .1.2.2-.1.3-.3-.2zm.6-.2v.8h.2v-.3l.2.3h.1l-.2-.3.2-.2q0-.3-.3-.3zm.2.2h.1l-.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "M28.4 14.5v.2h.2v.2l-.3-.1v.2h.2v.2L28 15l.2-.7h.3v.2zm.5 0h.1l.2.7.2-.5h.1l-.2.8h-.1l-.2-.7-.2.5h-.1zm.8 1.2.4-.6h.1l-.3.6.2.1v.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m30.8 15.6-.7.3.1.1h.2l.2.1-.1.2h.1zm-.1.2-.1.2-.1-.1zm1.2.9-.8.2v.1h.3l.1.2v.2zm-.2.2-.1.2-.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "M31.6 17.7v-.2l.7-.2-.3.5h.5l-.6.5V18l.3-.2h-.5l.3-.4zm1 .7h-.2l.1.2h-.1v-.2l-.3.1.1.2h-.1l-.1-.3.7-.2v.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m32.9 18.8-.8.2v.1h.4l-.3.2v.2l.3-.3h.2q.3 0 .2-.2zm-.1.2-.1.1h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "M33 19.7h-.7l.7-.2zm-.1.8v-.2q0-.2-.2-.2t-.3.2l.1.2h-.2v-.2a.4.4 0 0 1 .4-.4q.3 0 .4.4v.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M32.3 20.6v.1l.1.1v.3h-.2v.2l.8-.2V21zm.3.3h.2l-.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "m32.3 22.7.2-.1q0-.3-.2-.4l-.3.2v.2l-.1-.1v-.2a.4.4 0 0 1 .5-.2q.3.1.2.5l-.1.1zm0 .4L32 23l-.1.2h-.1v-.3h-.1l-.1.2-.1-.1.2-.4.6.4-.2.3H32zm-.2.5-.7.1.4.3-.1.1-.6-.4v-.1h.7l-.4-.3v-.1zm-.8.7h.2l-.3.3v-.2l-.4-.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m30.6 24.2-.2.1.2.3-.3-.2-.1.2h.3v.3q.2.2.4 0l.1-.1zm.1.4.1.2h-.1zm-.6 0H30v.3h-.5l.7.6zm0 .4v.2l-.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    d: "m29.4 25 .3.7h-.1l-.3-.5h-.2z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSv);
export default __webpack_public_path__ + "static/media/sv.3dbce6279aa0262554d10a4a9fce687c.svg";
export { ForwardRef as ReactComponent };